import React, {Component} from 'react';
import { CSSTransitionGroup } from 'react-transition-group'
import './Alert.css';

class Alert extends Component{
    constructor(props){
        super(props);
        this.state={
            show:true,
        };
        this._mount = true;
    }

    componentDidMount(){
        const inst = this;
        setTimeout(function () {
            if(inst._mount)
                inst.setState({show: false});
        }, this.props.time);
    }

    componentWillUnmount() {
        this._mount = false;
    }

    render(){
        const typeAlert = 'alert alert-' + (this.props.type ? this.props.type : 'success');
        const t = (this.props.type ? this.props.type : 'light');
        const typeAlertPanel = 'card '+(t != 'light' ? 'text-white': '')+' bg-' + t;
        const message = this.props.message;
        if(this.props.is_panel){
            return (
                <CSSTransitionGroup
                    transitionName="alert"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={true}
                    transitionLeaveTimeout={500}>
                    {this.state.show &&
                    <div className={typeAlertPanel}>
                        <div className="card-header with-border">
                            {this.props.title}
                        </div>
                        <div className="card-body">
                            {message}
                        </div>
                    </div>
                    }
                </CSSTransitionGroup>
            );
        } else if (this.props.is_html) {
            return (
                <CSSTransitionGroup
                    transitionName="alert"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={true}
                    transitionLeaveTimeout={500}>
                    {this.state.show &&
                        <div className={typeAlert} role="alert" dangerouslySetInnerHTML={{__html: message}} />}
                </CSSTransitionGroup>
            );
        }
        else{
            return (
                <CSSTransitionGroup
                    transitionName="alert"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={true}
                    transitionLeaveTimeout={500}>
                    {this.state.show && <div className={typeAlert} role="alert">{message}</div>}
                </CSSTransitionGroup>
            );
        }
    }
}

export default Alert;


// WEBPACK FOOTER //
// ./src/Alert/Alert.js